/* template */
<template><page><base-container :class='["button-group-demo"]'><view-desc>水平排列</view-desc><button-group-two/><view-desc>垂直排列</view-desc><button-group-vertical-two/><view-desc>图文结合</view-desc><button-group-with-context/></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_c4aa8c6c"}'>
.button-group-demo
  padding-left 0 !important
  padding-right 0 !important
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_c4aa8c6c"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_c4aa8c6c"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_c4aa8c6c"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'button-group-one':getComponent(require("./button-group-one.mpx?isComponent&outputPath=components%2Fbutton-group-one5b029cb3%2Findex")),'button-group-two':getComponent(require("./button-group-two.mpx?isComponent&outputPath=components%2Fbutton-group-two736a4d99%2Findex")),'button-group-vertical-two':getComponent(require("./button-group-vertical-two.mpx?isComponent&outputPath=components%2Fbutton-group-vertical-two21f186f6%2Findex")),'button-group-with-context':getComponent(require("./button-group-with-context.mpx?isComponent&outputPath=components%2Fbutton-group-with-context6f63e5a9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>